<template>
  <div class="ui-module-fade-in-up pa-4 inventario-armas-content">
    <v-tabs class="mb-3" v-model="selectedTab" color="secondary">
      <v-tab class="font-weight-bold">Movimientos</v-tab>
      <v-tab class="font-weight-bold">Inventario</v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab" class="transparent">
      <v-tab-item key="1" eager>
        <MovimientosTabContent />
      </v-tab-item>
      <v-tab-item key="2" eager>
        <InventarioTabContent />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import InventarioTabContent from './tab-content/InventarioTabContent.vue'
import MovimientosTabContent from './tab-content/MovimientosTabContent.vue'

export default {
  components: {
    InventarioTabContent,
    MovimientosTabContent,
  },
  data() {
    return {
      selectedTab: 0,
    }
  },
  async created() {
    await this.fetchCalibres()
    await this.fetchTiposArma()
    await this.fetchMarcaArma()
    await this.fetchEstatusArma()
    await this.fetchArmas()
    await this.fetchTipoAsignacion()
    await this.fetchTiposEntrega()
    await this.fetchEstatusMunicion()
    await this.fetchProcedencia()
    await this.fetchTipoItem()
    await this.fetchMovimientoMunicion()
    await this.fetchMovimientoArma()
    await this.fetchTipoMovimiento()
    await this.fetchClasesArmaCorta()
    await this.fetchClasesArmaLarga()
    await this.fetchMotivoUso()
    await this.fetchAccesorios()
  },
  methods: {
    ...mapActions('personal', ['fetchPersonal']),
    ...mapActions('calibre', ['fetchCalibres']),
    ...mapActions('tipoArma', ['fetchTiposArma']),
    ...mapActions('marcaArma', ['fetchMarcaArma']),
    ...mapActions('modeloArma', ['fetchModeloArmas']),
    ...mapActions('estatusArma', ['fetchEstatusArma']),
    ...mapActions('arma', ['fetchArmas']),
    ...mapActions('tipoAsignacionArma', ['fetchTipoAsignacion']),
    ...mapActions('tipoEntregaArma', ['fetchTiposEntrega']),
    ...mapActions('estatusMunicion', ['fetchEstatusMunicion']),
    ...mapActions('procedencia', ['fetchProcedencia']),
    ...mapActions('tipoItemArmeria', ['fetchTipoItem']),
    ...mapActions('movimientoMunicion', ['fetchMovimientoMunicion']),
    ...mapActions('movimientoArma', ['fetchMovimientoArma']),
    ...mapActions('tipoMovimientoEquipamiento', ['fetchTipoMovimiento']),
    ...mapActions('claseArma', ['fetchClasesArmaCorta', 'fetchClasesArmaLarga']),
    ...mapActions('motivoUso', ['fetchMotivoUso']),
    ...mapActions('accesorio', ['fetchAccesorios']),
  },
}
</script>

<style scoped>
.inventario-armas-content {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}
</style>
